import { compose, head, propOr } from 'ramda';

export default function mapOfferNodeLegendOptions (offerNode) {
  return {
    legends: propOr([], 'legend', compose(head, propOr([], 'options'))(offerNode)),
    options: propOr([], 'options', offerNode).map((option) => ({
      labels: compose(propOr([], 'label'))(option),
      value: propOr(null, 'value', option),
      recommended: propOr(false, 'recommended', option)
    }))
  };
}
